export const CUSTOM_TABLES_INDEXER_NOTIFICATION_PREFIX = 'customtables:indexer';
